/**
 * supabase.ts
 * ─────────────────────────────────────────────────────────────────────────────
 * src/shared/services/supabase.ts
 *
 * Single Supabase client instance for the entire app.
 * All modules import from here — never call createClient() elsewhere.
 *
 * Lock is a no-op function to prevent Navigator LockManager timeout issues.
 * The Supabase client expects lock to be a function, not a config object.
 * ─────────────────────────────────────────────────────────────────────────────
 */

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Check .env.local')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    lock: async (_name, _acquireTimeout, fn) => {
      // No-op lock — just run the function directly.
      // Bypasses the Web Locks API to prevent timeout issues.
      return await fn()
    },
  },
})
